import KeyComponent from "../components/keyComponent";

export const ComponentSection = {
  key: "component--key",
  component: KeyComponent,
};

export const DatoKeyValuesMap = [ComponentSection];
